import {FIELDS_PATTERN} from 'src/modules/event-create/constants';
import {AttributeChangeRequest} from 'src/openapi/models/AttributeChangeRequest';

export const MIN_LENGTH_ATTRIBUTE_NAME = 2;
export const MAX_LENGTH_ATTRIBUTE_NAME = 100;

const ATTRIBUTE_NAME_MIN_LENGTH = 'Some of the added attribute have incorrect name. ' +
    '"Attribute Name" length must be more than 1 character';

export const attributeNameValidation = (attributes: AttributeChangeRequest[], attributeName?: string): string[] => {
    const errorMassages: string[] = [];

    if (attributeName === undefined) {
        return errorMassages;
    }

    const matches = attributeName?.match(FIELDS_PATTERN.attributeName);

    const attributeNames = attributes.map(attr => attr.name);
    const duplicateAttributeNames = [
        ...new Set(attributeNames.filter((attr, index) => attributeNames.indexOf(attr) !== index && attr)),
    ];

    if (duplicateAttributeNames.length) {
        const s = duplicateAttributeNames.length > 1 ? 's' : '';
        errorMassages.push(`Attribute name${s} ${duplicateAttributeNames
            .map(name => `"${name}"`)
            .join(', ')
        } have duplicate${s}. "Attribute Name" should be unique for current event`);
    }

    if (attributeName.length < MIN_LENGTH_ATTRIBUTE_NAME) {
        errorMassages.push(ATTRIBUTE_NAME_MIN_LENGTH);
    }

    if (matches) {
        errorMassages.push(
            `"${attributeName}" incorrect attribute name.
            Use lowercase latin alphabet and underscore. Example: "account_license_id"`,
        );
    }
    return errorMassages;
};
